import { isView } from '@/utils/tools'
import { lang } from '@/config/env'

const apis = [
  {
    // 竞赛日程分页列表
    fn: 'getPageList',
    method: 'POST',
    url: '/api/jsSchedule/getPageList',
    hideLoading: true,
    processLang(res) {
      if (!isView()) return res
      if (lang === 'cn') return res
      if (!res) return res
      return {
        ...res,
        records: res.records.map(({ jsNameEn, titleEn, scheduleTimeEn, ...data }) => ({
          ...data,
          jsName: jsNameEn,
          title: titleEn,
          scheduleTime: scheduleTimeEn
        }))
      }
    }
  },
  {
    // 竞赛日程分页列表后台
    fn: 'getPageListAdmin',
    method: 'POST',
    url: '/api/jsSchedule/getPageListAdmin',
    hideLoading: true
  },
  {
    // 添加竞赛日程
    fn: 'add',
    method: 'POST',
    url: '/api/jsSchedule/add',
    hideLoading: true
  },
  {
    // 修改竞赛日程
    fn: 'update',
    method: 'POST',
    url: '/api/jsSchedule/update',
    hideLoading: true
  },
  {
    // 删除竞赛日程
    fn: 'delete',
    method: 'POST',
    url: '/api/jsSchedule/delete',
    hideLoading: true
  },
  {
    // 竞赛日程详情
    fn: 'info',
    method: 'POST',
    url: '/api/jsSchedule/info',
    hideLoading: true
  }
]

export default apis
